export default __webpack_public_path__ + "static/media/products-hero-picture.ab5914f2.png";